// extracted by mini-css-extract-plugin
export var locationCard = "_qk-0";